import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { JpmamVendorTabRail } from '../../../../../../../../../../features/vendor/jpmam/jpmam-vendor-tab-rail';
import { JpmamTasksTable } from '../../../../../../../../../../features/vendor/jpmam/task/jpmam-tasks-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorJpmam,
      label: 'Tasks',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorJpmam>,
  head: () => getPageHead('JPMAM Tasks'),
  component: JpmamTaskList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <VerticalStack gap={7}>
      <JpmamVendorTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
      />
    </VerticalStack>
  );
}

function JpmamTaskList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <JpmamTasksTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
